import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListingSyncProApiService } from '@vendasta/listing-sync-pro';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ListingSyncProModel {
  updated: string;
  created: string;
  listing_sync_pro_sources_enabled: string;
  reputation_activated: string;
  listing_sync_pro_service_provider: string;
  listing_sync_pro_activated: string;
  partner_id: string;
}

export interface GetListingSyncProModelResponse {
  isEnabled: boolean;
  dateSourcesEnabled: string;
  sourcesModel: ListingSyncProModel;
}

@Injectable({
  providedIn: 'root',
})
export class LspWrapperService {
  constructor(
    private lspService: ListingSyncProApiService,
    private apiClient: HttpClient,
  ) {}

  getLspProviders(partnerId: string): Observable<number[]> {
    return this.lspService.getAvailableProvidersForPartner({ partnerId }).pipe(map((resp) => resp.serviceProviders));
  }

  getLspModelForPartner(partnerId: string): Observable<GetListingSyncProModelResponse> {
    // We don't care about the other fields on the response, just the data field.
    return this.apiClient
      .get<{ data: GetListingSyncProModelResponse }>(`/_ajax/v1/listing-sync-pro-model/?partnerId=${partnerId}`)
      .pipe(map((response) => response.data));
  }
}
